<template>
    <div class="install-groups" :class="{loading: loading}">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Install Groups
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                        <button type="button" class="btn btn-sm btn-success" @click="open(null)"
                                :disabled="loading">
                            Create Install Group
                        </button>
                    </div>
                </div>
            </legend>

            <div class="form-group text-right">
                <div class="checkbox">
                    <label>
                        <input v-model.boolean="archived"
                               type="checkbox"
                               id="archived"
                               name="archived">
                        Show Archived
                    </label>
                </div>
            </div>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':selectedModelId === model.id}"
                   v-for="model in models"
                   :key="model.id"
                   @click="open(model.id)">
                    <h4 class="list-group-item-heading">
                        {{model.name}}
                        <span v-if="model.hasSentNotifications"
                              class="fa fa-bell text-green"
                              v-tooltip="'Notifications Sent'"></span>
                        <span v-else-if="model.hasNotifications"
                              class="fa fa-bell-o text-yellow"
                              v-tooltip="'Notifications Scheduled'"></span>
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                    <h6 v-for="unitEntries in model.unitEntries">
                        {{unitEntries.display_start_at}} - {{unitEntries.display_end_at}}
                    </h6>
                </a>
            </div>
        </fieldset>

        <install-group ref="installGroupComponent"
                        :project-id="projectId"
                        :model-id="selectedModelId"
                        @afterSave="afterSave">
            <span></span>
        </install-group>
    </div>
</template>

<script>
    import models from "./mixins/models";
    import InstallGroup from "./InstallGroup";

    export default {
        components: { InstallGroup },
        mixins: [ models ],

        props: {
            projectId: {
                required: true,
                type: String
            },
        },

        computed: {
            // Override
            modelComponent(){
                return 'installGroupComponent';
            },

            resourceKey(){
                return 'InstallGroups';
            },

            url(){
                return '/api/installGroups?project_id=' + this.projectId + '&sort_by=name&sort_dir=ASC';
            },
        },

        methods: {
            getModelsData(){
                return {};
            },

            setModels( response ){
                var installGroups =
                    response.data.InstallGroups.map( ( installGroup ) => {
                        var notifications = this.getInstallGroupNotifications( installGroup );
                        var sentNotifications = {
                            email: _.filter( notifications.email, function( notification ){
                                return notification.sent_at !== null;
                            } ),
                            sms: _.filter( notifications.sms, function( notification ){
                                return notification.sent_at !== null;
                            } ),
                        };
                        installGroup.hasSentNotifications = sentNotifications.email.length > 0 || sentNotifications.sms.length > 0;

                        installGroup.residentCount = installGroup.residents.length;
                        installGroup.hasNotifications = notifications.email.length > 0 || notifications.sms.length > 0;

                        return installGroup;
                    } );

                return this.$set( this, 'models', installGroups );
            },

            getInstallGroupNotifications( installGroup ){
                return _.reduce( installGroup.unitEntries, function( result, unitEntry ){
                    result.email = _.concat( result.email, unitEntry.emailNotifications );
                    result.sms = _.concat( result.sms, unitEntry.smsNotifications );

                    return result;
                }, {
                    email: [],
                    sms: [],
                } );
            }
        }
    }
</script>
